import { render, staticRenderFns } from "./PerformanceTemplate.vue?vue&type=template&id=d5acf52a&scoped=true"
import script from "./PerformanceTemplate.vue?vue&type=script&lang=js"
export * from "./PerformanceTemplate.vue?vue&type=script&lang=js"
import style0 from "./PerformanceTemplate.vue?vue&type=style&index=0&id=d5acf52a&prod&lang=css"
import style1 from "./PerformanceTemplate.vue?vue&type=style&index=1&id=d5acf52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5acf52a",
  null
  
)

export default component.exports